import React, { Component, Fragment } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';

class tabGeneral extends Component {

    render() {
        const { Datos, columnasPagos, listPagos } = this.props;
        return (
            <Fragment>
                <div className="row">
                    <div className="col">
                        <label>{Datos.Entrega.attributes.label}</label>
                        <p>{Datos.Entrega.value}</p>
                    </div>
                    <div className="col">
                        <label>{Datos.Fecha.attributes.label}</label>
                        <p>{Datos.Fecha.value}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <label>{Datos.Usuario.attributes.label}</label>
                        <p>{Datos.Usuario.value}</p>
                    </div>
                    <div className="col">
                        <label>{Datos.Monto.attributes.label}</label>
                        <p>{Datos.Monto.value}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <label>{Datos.Cliente.attributes.label}</label>
                        <p>{`${Datos.Cliente.value} ${Datos.Nombre.value}`}</p>
                    </div>
                    <div className="col">
                        <label>{Datos.Tiempo.attributes.label}</label>
                        <p>{Datos.Tiempo.value}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <label>{Datos.Repartidor.attributes.label}</label>
                        <p>{Datos.Repartidor.value}</p>
                    </div>
                    <div className="col">
                        <label>{Datos.Estatus.attributes.label}</label>
                        <p>{Datos.Estatus.value}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <label>{Datos.Factura.attributes.label}</label>
                        <p>{Datos.Factura.value}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className='table-responsive'>
                            <BootstrapTable keyField='llave' data={listPagos} columns={columnasPagos} />
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default tabGeneral;
